import { registerLocaleData } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import localeEsDO from '@angular/common/locales/es';
import { LOCALE_ID, provideBrowserGlobalErrorListeners } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { PreloadAllModules, provideRouter, withHashLocation, withPreloading } from '@angular/router';
import { provideErrorHandler } from '@providers/common';
import { Notify } from 'notiflix';
import { App } from './app/app.component';
import { routes } from './app/app.routes';

registerLocaleData(localeEsDO, 'es-DO');

Notify.init({
  position: 'right-bottom',
  timeout: 4000,
  fontSize: '13px',
  width: '320px',
  cssAnimationStyle: 'from-right'
});

bootstrapApplication(App, {
  providers: [
    provideBrowserGlobalErrorListeners(),
    { provide: LOCALE_ID, useValue: 'es-DO' },
    provideHttpClient(),
    provideErrorHandler(),
    provideRouter(routes, withHashLocation(), withPreloading(PreloadAllModules))
  ]
}).catch(err => console.error(err));
